<div class="map-container" >
    <div class="_h-full" #mapElem></div>
    <ng-content></ng-content>
</div>

<div *ngIf="(apiLoaded$ | async) as apiLoaded" [hidden]="true">
    <span *ngIf="apiLoaded && (listingMapMarkers$ | async) as listings">
        <app-map-marker 
            *ngFor="let listing of listings; let index = index; let isLast = last"
            [listing]="listing" 
            [map]="map" 
            [hoveredListingId$]="hoveredListingId$"
            [infoWindowListingId$]="infoWindowListingId$"
            (clicked)="openInfoWindow($event, listing)"
            [index]="index"
            (initializeClusterer)="onLastMarkerRendered()"
            last-item [isLastItem]="isLast" (onLastItem)="onLastMarkerRendered()">
        </app-map-marker>
    </span>
</div>
<div [hidden]="true">
    <div #infoWindow *ngIf="(infoWindowListing$ | async) as listing">
        <div class='map-info-window' (click)="openListingDetailsInNewTab(listing.listingId)">
            <img class='listing-image' app-imagekit [source]="coverImageUrl(listing)" width="240" height="130"
                 transform="tr:w-240,h-130,fo-auto">
            <div class='content-container'>
                <div class='title text-small heading'>{{ listing.summary.title }}</div>
                <div class='location text-extra-small'>{{ listing.summary.city }}
                    , {{ listing.summary.countryCode }}
                </div>
                <div class='deciding-factors text-extra-small'>
                    <div class='deciding-factor'
                         *ngFor="let df of listing.summary.decidingFactors.primaryDecidingFactors">
                        <i class="fa-light" [ngClass]="df.icon | faIconMap"></i>
                        <div>{{ df.title }}</div>
                    </div>
                </div>
                <div *ngIf="listing.fees && listing?.fees?.bookingFee?.amountMicros > 0" class='pricing'>
                    <div class="rack-rate">
                        <span>Rate from </span>
                        <span class="price"><app-booking-price [fees]="listing.fees"></app-booking-price></span>
                    </div>
                    <app-reseller-commission-calculation
                            [exactFee]="listing.fees"></app-reseller-commission-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
